import { BasisTypeCardsTemplate, CustomerTypeCardsTemplate } from '../chemistry'
import BasisTypesPage from './page'
import BasisTemplate from './template'
import { StyledBasisTypes } from './styles'

export {
    BasisTemplate,
    BasisTypeCardsTemplate,
    CustomerTypeCardsTemplate,
    StyledBasisTypes,
}

export default BasisTypesPage
